export default __webpack_public_path__ + "static/media/manhattan_from_ferry.c032303e.jpg";